"use client";

import { useEffect, useState } from "react";

import { Moon, Sun } from "lucide-react";

import { CLAVE_TEMA } from "@/scripts/tema-boot";

/**
 * El interruptor de tema claro/oscuro.
 *
 * ⚠️ **No renderiza el ícono hasta después de montar, y no es una torpeza.** El tema real lo decide un
 * script en línea *antes* de que React exista (ver `tema-boot.tsx`), así que el servidor **no puede
 * saber** cuál va a ser: pintar un sol o una luna en el HTML acertaría la mitad de las veces y daría un
 * error de hidratación la otra mitad. Reservando el hueco no hay salto de maquetación.
 */
export function TemaToggle() {
  const [montado, setMontado] = useState(false);
  const [oscuro, setOscuro] = useState(false);

  useEffect(() => {
    setOscuro(document.documentElement.classList.contains("dark"));
    setMontado(true);
  }, []);

  const alternar = () => {
    const siguiente = !oscuro;
    setOscuro(siguiente);
    document.documentElement.classList.toggle("dark", siguiente);
    try {
      window.localStorage.setItem(CLAVE_TEMA, siguiente ? "oscuro" : "claro");
    } catch {
      /* Navegación privada: el tema vale para esta pestaña y no se recuerda. Mejor eso que reventar. */
    }
  };

  return (
    <button
      type="button"
      onClick={alternar}
      aria-label={oscuro ? "Cambiar a tema claro" : "Cambiar a tema oscuro"}
      title={oscuro ? "Tema claro" : "Tema oscuro"}
      className="flex size-9 shrink-0 items-center justify-center rounded-lg text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
    >
      {montado ? oscuro ? <Moon className="size-4" /> : <Sun className="size-4" /> : <span className="size-4" />}
    </button>
  );
}
